"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intl = require("@kyruus/intl");
var _moment = _interopRequireDefault(require("moment"));
var _utils = require("../../../lib/utils");
var _messages = _interopRequireDefault(require("../../../lib/messages"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const PatientStaticInfo = _ref => {
  let {
    name,
    dob,
    gender,
    address,
    bannerText,
    fields
  } = _ref;
  const showName = !(0, _some.default)(fields).call(fields, field => field.type === 'name');
  const showDob = !(0, _some.default)(fields).call(fields, field => field.type === 'dob');
  // Gender form fields are type `simpleSelect`, need to use path instead
  const showGender = !(0, _some.default)(fields).call(fields, field => field.path === 'patient.gender');
  const showAddress = !(0, _some.default)(fields).call(fields, field => field.type === 'address');
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, (showName || showDob || showGender || showAddress) && /*#__PURE__*/_react.default.createElement(_styles.Header, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.demographicsFormHeader)), bannerText && /*#__PURE__*/_react.default.createElement(_styles.InfoBanner, null, bannerText), showName && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.demographicsFormNameLabel)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, (0, _utils.toTitleCase)((0, _utils.makeNameString)(name)))), showDob && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.demographicsFormDobLabel)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, (0, _moment.default)(dob).format('MM/DD/YYYY'))), showGender && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.demographicsFormGenderLabel)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, (0, _utils.toTitleCase)(gender))), showAddress && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_styles.Label, null, /*#__PURE__*/_react.default.createElement(_intl.FormattedMessage, _messages.default.demographicsFormAddressLabel)), /*#__PURE__*/_react.default.createElement(_styles.Text, null, address.street1 && /*#__PURE__*/_react.default.createElement("div", null, (0, _utils.toTitleCase)(address.street1)), address.street2 && /*#__PURE__*/_react.default.createElement("div", null, (0, _utils.toTitleCase)(address.street2)), (address.city || address.state || address.zip) && /*#__PURE__*/_react.default.createElement("div", null, address.city ? `${(0, _utils.toTitleCase)(address.city)}, ` : null, address.state ? `${address.state.toUpperCase()} ` : null, address.zip ? `${address.zip} ` : null), address.country && /*#__PURE__*/_react.default.createElement("div", null, address.country.toUpperCase()))));
};
PatientStaticInfo.defaultProps = {
  name: {},
  dob: null,
  gender: null,
  address: {},
  bannerText: null,
  fields: []
};
PatientStaticInfo.propTypes = {
  name: _propTypes.default.shape({
    first: _propTypes.default.string,
    middle: _propTypes.default.string,
    last: _propTypes.default.string
  }),
  dob: _propTypes.default.string,
  gender: _propTypes.default.string,
  address: _propTypes.default.shape({
    street1: _propTypes.default.string,
    street2: _propTypes.default.string,
    city: _propTypes.default.string,
    state: _propTypes.default.string,
    zip: _propTypes.default.string,
    country: _propTypes.default.string
  }),
  bannerText: _propTypes.default.string,
  fields: _propTypes.default.array
};
var _default = exports.default = PatientStaticInfo;
PatientStaticInfo.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PatientStaticInfo",
  "props": {
    "name": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "first": {
            "name": "string",
            "required": false
          },
          "middle": {
            "name": "string",
            "required": false
          },
          "last": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "dob": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "gender": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "address": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "street1": {
            "name": "string",
            "required": false
          },
          "street2": {
            "name": "string",
            "required": false
          },
          "city": {
            "name": "string",
            "required": false
          },
          "state": {
            "name": "string",
            "required": false
          },
          "zip": {
            "name": "string",
            "required": false
          },
          "country": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "bannerText": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "fields": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "array"
      },
      "required": false
    }
  }
};